import {
  type UseIsFeatureEnabled,
  useIsFeatureEnabledUntyped,
} from "@fideus/feature-flags/react";
import type { FeatureFlag } from "@fideus-core/feature-flags";

export const useIsFeatureEnabled =
  useIsFeatureEnabledUntyped as unknown as UseIsFeatureEnabled<FeatureFlag>;
